export default "__VITE_ASSET__DrkaZPOH__"